import { deleteApi, patchApi, postApi, putApi } from '../../../../utils/api'
import { DOC_FLOW_API_URL } from '../../DocFlow.constants'

import { DOC_FLOW_MAPPING_RESULT_TABLE_CONFIG_URL } from './DocFlowMappingResultTable.constants'

export function updateDocFlowMappingResultTableConfig(data) {
  return putApi({
    data,
    endpoint: `${DOC_FLOW_MAPPING_RESULT_TABLE_CONFIG_URL}config/`,
  })
}

export function getDocFlowMappingResults({ data, documentId, itemId }) {
  return postApi({
    data,
    endpoint: `${DOC_FLOW_API_URL}${documentId}/uploading-files/${itemId}/results/filter/`,
  })
}

export function performDocFlowMappingResultMassAction({
  data,
  documentId,
  itemId,
}) {
  return postApi({
    data,
    endpoint: `${DOC_FLOW_API_URL}${documentId}/uploading-files/${itemId}/results/mass-action/`,
  })
}

export function updateDocFlowMappingResultItem({
  data,
  documentId,
  itemId,
  resultItemId,
}) {
  return patchApi({
    data,
    endpoint: `${DOC_FLOW_API_URL}${documentId}/uploading-files/${itemId}/results/${resultItemId}/`,
  })
}

export function deleteDocFlowMappingResultItem({
  documentId,
  itemId,
  resultItemId,
}) {
  return deleteApi({
    endpoint: `${DOC_FLOW_API_URL}${documentId}/uploading-files/${itemId}/results/${resultItemId}/`,
  })
}
